import {SearchParameters} from '@findhotel/sapi'
import {map, pipe} from 'ramda'
import {replaceCheckOutWithMlos} from 'utils/searchParams'

import {validateSearchParamDates} from '@vio/core/src/searchParams/validateSearchParamDates'

import {objectFromURLSearchParams} from './generic'

/**
 * Return only the first element when URL params are an array (ie. duplicated)
 */
const flattenArrayParams = (
  params: Record<string, string | string[]>
): Record<string, string> =>
  map(value => (Array.isArray(value) ? value[0] : value), params)

/**
 * Extract and validate checkIn and checkOut dates
 * The validation requires other params, so pass all parameters.
 **/
export const getCheckInCheckOutDates = (
  queryParams: URLSearchParams
): Pick<SearchParameters, 'checkIn' | 'checkOut'> => {
  const {checkIn, checkOut} = pipe(
    objectFromURLSearchParams,
    flattenArrayParams,
    validateSearchParamDates,
    replaceCheckOutWithMlos
  )(queryParams)

  return {checkIn, checkOut}
}
